import type { FromURL } from "@/features/flow/types";
import { PartnerCardHeader } from "./my-partner-card-header";
import { type PartnerCardListType, TransfertCardList } from "./my-partner-card-list";

type MyPartnerardType = {
  isDark: boolean;
  partnerList: PartnerCardListType[];
  updatePartner: (
    partner: FromURL,
    url: string,
    partnerType?: string,
    lang?: string
  ) => Promise<void>;
};
export const MyPartnerCard = (props: MyPartnerardType) => {
  return (
    <div className="mt-10">
      <PartnerCardHeader />
      <div className="flex flex-col">
        {(props.partnerList ?? []).map((p) => (
          <TransfertCardList
            host={p.host}
            name={p.name}
            updatePartner={props.updatePartner}
            key={p.tokenName}
            mode={p.mode}
            balance={p.balance}
            onChainBalance={p.onChainBalance}
            partner={p.partner}
            src={p.src}
            tokenName={p.tokenName}
          />
        ))}
      </div>
    </div>
  );
};
